import $ from 'jquery';
import Nav from 'partials/site/header/nav/nav';
import Ask from 'partials/site/header/ask/ask';
import Region from 'partials/site/header/region/region';
import User from 'partials/site/header/user/user';

export default class {
	constructor() {
		this.$header = $('#header');
		this.nav = new Nav();
		this.region = new Region();
		this.ask = new Ask();
		this.user = new User();
		return this;
	}

	render() {
		if (this.$header.length) {
			this.nav.render();
			this.region.render();
			this.ask.render();
			this.user.render();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/partials/site/header/header.js